"use strict";
exports.__esModule = true;
var utils_1 = require("@lglp/utils");
exports["default"] = utils_1.extract([
    // React attributes
    'className',
    'children',
    'dangerouslySetInnerHTML',
    'defaultChecked',
    'defaultValue',
    'htmlFor',
    /^on/,
    'ref',
]);
//# sourceMappingURL=react.js.map